import React from 'react';
import { t } from '../i18n';

const Terms = () => {
    const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'support@painttheworld.app';

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>{t('web.terms.title')}</h1>
            <p style={styles.updated}>{t('web.terms.lastUpdated')}</p>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.acceptanceTitle')}</h2>
                <p style={styles.body}>{t('web.terms.acceptanceBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.useTitle')}</h2>
                <p style={styles.body}>{t('web.terms.useBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.accountTitle')}</h2>
                <p style={styles.body}>{t('web.terms.accountBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.gameplayTitle')}</h2>
                <p style={styles.body}>{t('web.terms.gameplayBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.disclaimerTitle')}</h2>
                <p style={styles.body}>{t('web.terms.disclaimerBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.changesTitle')}</h2>
                <p style={styles.body}>{t('web.terms.changesBody')}</p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.terms.contactTitle')}</h2>
                <p style={styles.body}>{t('web.terms.contactBody')} <a href={`mailto:${contactEmail}`} style={styles.link}>{contactEmail}</a></p>
            </section>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    container: { maxWidth: 640, margin: '0 auto', padding: '24px 16px', fontFamily: 'system-ui, sans-serif', color: '#eee', backgroundColor: '#111', minHeight: '100vh' },
    heading: { color: '#fff', fontSize: 28, fontWeight: 700, marginBottom: 4 },
    updated: { color: '#666', fontSize: 13, marginBottom: 32 },
    section: { marginBottom: 28 },
    sectionHeading: { color: '#fff', fontSize: 18, fontWeight: 600, marginBottom: 12 },
    body: { color: '#eee', lineHeight: 1.7 },
    link: { color: '#6ab4ff' },
};

export default Terms;
